<template>
  <div>
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from "./components/global/Header";
import Footer from "./components/global/Footer";

export default {
  name: "app",
  components: {
    Header,
    Footer
  },
  mounted() {
    this.$store.commit("setMenu", window.init.menu);
  }
};
</script>

<style lang="scss">
@import "./sass/app";
</style>
